import Page from '@averyano/core/src/classes/Page';
import each from 'lodash/each';

export default class ConfirmationPage extends Page {
	constructor(el) {
		super({
			element: el,
		});
		this.id = 'confirmation';
	}

	create() {
		if (this.template != this.id) return;

		if (!this.isReady) super.createComponent();
	}

	onResize() {}
}
